import normalizeTranslations from "actions/translations";

// The picture is a writableLink=false MediaObject relation: API Platform requires an IRI, not a
// nested object. Both a freshly uploaded picture and one coming from the item GET are full objects,
// so flatten them to their IRI (a removed picture stays null).
function pictureIri(picture) {
    if (picture && "object" === typeof picture) {
        return picture["@id"] ?? picture;
    }

    return picture;
}

/**
 * Builds the PUT payload from the edit form state. Only the fields the form edits are sent
 * (API Platform keeps the current value of omitted fields): the name is read-only because it
 * fixes the Sylius taxon code.
 *
 * Locales are the union of the existing translations and the edited values, so content entered
 * for a locale that has no translation record yet (e.g. a picture uploaded there) is not lost.
 * Existing translations keep their @id so API Platform updates them in place; new ones get their
 * `locale` set by normalizeTranslations.
 */
export default function buildUpdatePayload(brand, {enabled, descriptions, longDescriptions, pictures, ctaLinks}) {
    const localeCodes = new Set([
        ...Object.keys(brand.translations ?? {}),
        ...Object.keys(descriptions ?? {}),
        ...Object.keys(longDescriptions ?? {}),
        ...Object.keys(pictures ?? {}),
    ]);

    const translations = {};
    localeCodes.forEach((code) => {
        translations[code] = {
            ...(brand.translations?.[code] ?? {}),
            description: descriptions?.[code],
            longDescription: longDescriptions?.[code],
            picture: pictureIri(pictures?.[code]),
        };
    });

    return normalizeTranslations({enabled, translations, ctaLinks});
}
